import { render, staticRenderFns } from "./CompanyInformation.vue?vue&type=template&id=2aed03c9&scoped=true&"
import script from "./CompanyInformation.vue?vue&type=script&lang=js&"
export * from "./CompanyInformation.vue?vue&type=script&lang=js&"
import style0 from "./CompanyInformation.vue?vue&type=style&index=0&id=2aed03c9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aed03c9",
  null
  
)

export default component.exports